<template>
  <div>
    <header
      v-if="layoutStore.isNavigationHeaderVisible"
      :class="{ shadow: isScrolled }"
    >
      <!--      TODO: this component is currently a wrapper for the new navigation, render the new component directly once the auth code is refactored-->
      <HeaderNavigation
        v-if="navigationData"
        @open-drawer="drawerOpen = true"
        @close-drawer="drawerOpen = false"
        :languageLinks="languageLinks"
        :navigationData="navigationData"
      ></HeaderNavigation>
    </header>
    <div
      id="transparent-black"
      v-if="drawerOpen"
      @click="handleLayoverClick"
    ></div>
    <main id="main-content">
      <Snackbar />
      <NuxtPage />
    </main>

    <footer v-if="layoutStore.isFooterVisible && footerData">
      <LayoutAppFooter
        :legal-links="footerData.legalLinks"
        :disclaimer="footerData.disclaimer"
        :social-links="footerData.showSocialLinks"
        :navigation-groups="footerData.footerNavigation"
        v-if="footerFeatureFlag"
      />
      <DeprecatedFooter v-else />
    </footer>
  </div>
</template>
<script setup lang="ts">
import type { FooterSkeleton } from "#shared/types/contentful";

const { locale } = useI18n();
const footerFeatureFlag = useCookie("_ff_FOJO-2473-footer");
useHead({
  htmlAttrs: {
    lang: locale.value,
  },
});

const { data: footerData } = await useFetch<FooterSkeleton["fields"]>(
  "/api/v2/footer",
  { query: { locale } },
  {
    transform: (data) => {
      return data.fields;
    },
  },
  {
    onResponseError({ response }) {
      const { status: statusCode, statusText: message } = response;

      throw showError({
        statusCode,
        message,
      });
    },
  },
);

const { data: navigationData } = await useFetch("/api/v2/navigation", {
  query: { locale },
});

const layoutStore = useLayoutStore();
const { drawerOpen, resetNavigationActiveState } = useNavigationDeprecated();
const { y: yScrollPosition } = useScroll(document);

const languageLinks = ref();

const isScrolled = computed(() => yScrollPosition.value > 0);

function handleLayoverClick() {
  drawerOpen.value = false;
  resetNavigationActiveState();

  /**
   * TODO: remove this when Navigation is refactored
   *
   * SEE: https://citizenm.atlassian.net/browse/FOJO-2245
   */
  if (import.meta.client) {
    document.body.style.overflow = "auto";
  }
}

if (import.meta.client) {
  window.cmtr;
}
</script>

<style lang="scss" scoped>
header {
  background-color: var(--primary-white);
  height: var(--header-navigation-height-mobile, 60px);
  margin: 0;
  width: 100%;
  top: 0;
  position: fixed;
  z-index: 33;

  @include xl {
    height: var(--header-navigation-height, 80px);
  }
}

#transparent-black {
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.33);
  position: fixed;
  z-index: 15;
}

.shadow {
  box-shadow: var(--shadow);
  transition: 0.3s;
}

#main-content {
  margin-top: var(--header-navigation-height-mobile, 60px);
  min-height: 95vh;

  @include xl {
    margin-top: var(--header-navigation-height, 80px);
  }
}
</style>
